import Vue from 'vue';
import Router from 'vue-router';
import SupplyChain from './SupplyChain.vue';
import AddProduct from './AddProduct.vue';
import OrderLists from './OrderList.vue';
import Brokerage from './Brokerage.vue';
import Charge from './Charge.vue';
import Management from './Management.vue';
// import OrderDetail from './OrderDetail.vue';
import OrderDetail1 from './OrderDetail1.vue';
import order_report from './Report.vue';
import UserInfo from './UserInfo.vue';
import GoodsSetup from './GoodsSetup'
import GoodsSetups from './GoodsSetups'
import SetPosition from './SetPosition.vue';
import C from '../Container'

import Login from './Login'//登录
import OrderList2 from './OrderList2'
import InstallationCompany from './InstallationCompany'//安装公司
import install_list from './InstallationList'//安装单
import DriverList from './DriverList' //送货司机
import WuliuList from './WuliuList' //物流公司
import install_report from './InstallSingleReport' //安装单报表
import install_jiesuan from './SettlementReportform' //结算单报表
import Mendian from './Mendian'
import InquiryList from './InquiryList'
import ProjectList from './ProjectList'
import Announcement from './Announcement'
import Cangku from './Cangku'
import Fahuo from './Cangku2'
import Dayin from './Dayin'
import CangkuDayin from './CangkuDayin'
import CangkuDayin2 from './CangkuDayin2'

import DeFuil from './Defuil'
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/Login'
        },
        {
            path: '/C',
            name: 'C',
            component: C,
            children: [
                {
                    path: '/InstallationCompany',
                    name: 'InstallationCompany',
                    component: InstallationCompany,
                    meta: {
                        keepAlive: false
                    }
                }, //安装公司
                {
                    path: '/OrderLists',
                    name: 'OrderLists',
                    component: OrderLists, //订单列表
                    meta: {
                        keepAlive: true // 需要被缓存
                    }
                },
                {
                    path: '/OrderList2',
                    name: 'OrderList2',
                    component: OrderList2,
                    meta: {
                        keepAlive: false
                    }//2.2订单列表
                },
                {
                    path: '/Mendian',
                    name: 'Mendian',
                    component: Mendian,
                    meta: {
                        keepAlive: true
                    }//2.2订单列表
                },
                {
                    path: '/install_list',
                    name: 'install_list',
                    component: install_list,
                    meta: {
                        keepAlive: false
                    }//安装列表
                },
                {
                    path: '/DriverList',
                    name: 'DriverList',
                    component: DriverList,
                    meta: {
                        keepAlive: false
                    }//送货司机列表
                },
                {
                    path: '/WuliuList',
                    name: 'WuliuList',
                    component: WuliuList,
                    meta: {
                        keepAlive: false
                    }//物流公司列表
                },
                {
                    path: '/install_report',
                    name: 'install_report',
                    component: install_report,
                    meta: {
                        keepAlive: false
                    }//安装单报表
                },
                {
                    path: '/install_jiesuan',
                    name: 'install_jiesuan',
                    component: install_jiesuan,
                    meta: {
                        keepAlive: false
                    }//结算报表
                },
                {
                    path: '/DeFuil',
                    name: 'DeFuil',
                    component: DeFuil,
                    meta: {
                        keepAlive: false
                    }
                },
                {
                    path: '/Cangku',
                    name: 'Cangku',
                    component: Cangku,
                    meta: {
                        keepAlive: false
                    }//仓库带发货列表
                },
                {
                    path: '/Fahuo',
                    name: 'Fahuo',
                    component: Fahuo,
                    meta: {
                        keepAlive: false
                    }//仓库已发货列表
                },
                {
                    path: '/InquiryList',
                    name: 'InquiryList',
                    component: InquiryList //询价单列表
                },
                {
                    path: '/ProjectList',
                    name: 'ProjectList',
                    component: ProjectList //项目列表
                },
                {
                    path: '/Announcement',
                    name: 'Announcement',
                    component: Announcement //公告
                },
                // {
                //     path: '/OrderList/:id',
                //     name: 'OrderDetail',
                //     component: OrderDetail,
                //     meta: {
                //         keepAlive: false
                //     }
                // },
                {
                    path: '/OrderList/:id',
                    name: 'OrderDetail1',
                    component: OrderDetail1,
                    meta: {
                        keepAlive: false
                    }
                },
                {
                    path: '/SupplyChain',
                    name: 'SupplyChain',
                    component: SupplyChain,
                    meta: {
                        keepAlive: false
                    }
                }, {
                    path: '/SupplyChain/AddProduct',
                    name: 'AddProduct',
                    component: AddProduct
                }, {
                    path: '/Brokerage',
                    name: 'Brokerage',
                    component: Brokerage
                }, {
                    path: '/Charge',
                    name: 'Charge',
                    component: Charge
                }, {
                    path: '/Management',
                    name: 'Management',
                    component: Management
                }, {
                    path: '/order_report',
                    name: 'order_report',
                    component: order_report,
                    meta: {
                        keepAlive: false
                    }//结算报表
                }, {
                    path: '/UserInfo',
                    name: 'UserInfo',
                    component: UserInfo
                }, {
                    path: '/SetPosition',
                    name: 'SetPosition',
                    component: SetPosition
                },
                {
                    path: '/GoodsSetup',
                    name: 'GoodsSetup',
                    component: GoodsSetup
                },
                {
                    path: '/GoodsSetups',
                    name: 'GoodsSetups',
                    component: GoodsSetups
                }
                ]
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/Dayin',
            name: 'Dayin',
            component: Dayin
        },
        {
            path: '/CangkuDayin',
            name: 'CangkuDayin',
            component: CangkuDayin
        },
        {
            path: '/CangkuDayin2',
            name: 'CangkuDayin2',
            component: CangkuDayin2
        },

    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js